import React from 'react';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { PsPage } from '../../../shared/components/ps-page/PsPage';
import { MachineListCard } from './MachineListCard';
import { BreadcrumbsManagerInstance } from '../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../shared/breadcrumbs/Breadcrumbs';
import { CardStorageManager } from '../../../shared/utils/CardStorageManager';

export class MachineListScreen extends React.Component {

    cardStorageManager = new CardStorageManager(this.props.location.pathname);

    constructor(props) {
        super(props);

        this.cardStorageManager.init();

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_MACHINES,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MAQUINARIA_DE_MIS_SUBCONTRATAS')} breadcrumbs={breadcrumbs}>
                <MachineListCard
                    saveCardState={this.saveCardState}
                    initialCardState={this.readCardState()}
                />
            </PsPage>
        );
    }

    saveCardState = (state) => {
        this.cardStorageManager.saveCard('outsourceMachines', state);
    };

    readCardState = () => {
        return this.cardStorageManager.readCard('outsourceMachines');
    };
}

MachineListScreen.propTypes = {};

MachineListScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/list/MachineListScreen.jsx